module.exports = __webpack_public_path__ + "img/btn_menu_wxz_c.9e03d3a5.png";